// Test IDs for order placement (the confirmation screen talks to POST /api/orders,
// which can reject a stop-listed dish). Keys camelCase, values kebab-case.

export const ORDER = {
	error: 'confirm-error',
	retryButton: 'confirm-retry-button',
};
